import axios from "./axios";

export const getClientFundsData = async () => {
  const response = await axios.get("/api/broker-gateway/client-funds-data/");
  return response.data;
};
